import { render, staticRenderFns } from "./ClinicaSalud.vue?vue&type=template&id=28a830e4&scoped=true"
import script from "./ClinicaSalud.vue?vue&type=script&lang=js"
export * from "./ClinicaSalud.vue?vue&type=script&lang=js"
import style0 from "./ClinicaSalud.vue?vue&type=style&index=0&id=28a830e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a830e4",
  null
  
)

export default component.exports